import cn from 'classnames';
import {
  TouchableButton,
  TouchableImage,
} from '../../../common/Touchable/index';
import { LABEL } from '../../../../veriables';
import style from '../../serverAppPaymentScreens.module.scss';
const PaymentOption = ({
  seat,
  deviceInfo,
  handleGiftCardPayment,
  creditCardReadyScreen,
  serverAppTheme,
  buttonImage,
  isLandScape
}) => {
  const showPaymentOption =
    deviceInfo?.deviceGroup?.paymentTypes?.creditCard ||
    seat?.paymentCheck?.paymentAmount?.toFixed(2) === '0.00';
  if (showPaymentOption) {
    if (seat?.paymentCheck?.paymentAmount?.toFixed(2) !== '0.00' && buttonImage?.paymentCreditCardButtonImageUrl?.length > 0) {
      return (
        <TouchableImage
          className={cn('w-100 h-100 mt-1', seat?.paymentCheck?.paymentAmount > 0 ? 'mb-2' : 'mb-0')}
          src={buttonImage?.paymentCreditCardButtonImageUrl}
          tabIndex="0"
          role="button"
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            seat?.paymentCheck?.paymentAmount?.toFixed(2) === '0.00'
              ? handleGiftCardPayment()
              : creditCardReadyScreen();
          }}
          alt="paymentCreditCardButtonImageUrl"
        />
      );
    } else {
      return (
        <TouchableButton
          type="button"
          className={cn(
            'rounded btn-ripple w-100 btn68 od-primary-btn-bg-color od-primary-btn-font-color',
            seat?.paymentCheck?.paymentAmount > 0 ? 'mt-1' : '',
            (seat?.paymentCheck?.paymentAmount > 0 && isLandScape) ? style.btnht : ''
          )}
          style={{
            background: serverAppTheme?.secondaryBtn,
            color: serverAppTheme?.btn_font_color,
          }}
          onClick={() => {
            seat?.paymentCheck?.paymentAmount?.toFixed(2) === '0.00'
              ? handleGiftCardPayment()
              : creditCardReadyScreen();
          }}
          rippleEffect={true}
        >
          <div>
            <div>
              {seat?.paymentCheck?.paymentAmount.toFixed(2) === '0.00'
                ? `${LABEL().OS_COMPLETE_PAYMENT}`
                : `${LABEL().OS_PAY_WITH_CARD}`}{' '}
            </div>
          </div>
        </TouchableButton>
      );
    }
    return null;
  }
};

export default PaymentOption;
